export const tagColors = [
  { color: '#B24BB7', backgroundColor: '#D872DD1A' },
  { color: '#009308', backgroundColor: '#17B61F1A' },
  { color: '#C8A507', backgroundColor: '#F4D5481A' },
  { color: '#A2363B', backgroundColor: '#CB444A1A' },
];
